import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-permit-type-document',
  templateUrl: './permit-type-document.component.html',
  styleUrls: ['./permit-type-document.component.css']
})
export class PermitTypeDocumentComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
